import { Component } from '@angular/core';
import * as navigationData from '../dashboard-navigation.json';
import { BudgetsService } from './service/budgets.service';

@Component({
  selector: 'apc-budgets',
  templateUrl: './budgets.component.html',
  styleUrls: ['./budgets.component.scss', '../dashboard.component.scss'],
  providers: [ BudgetsService ]
})
export class BudgetsComponent {
  public navigation = (navigationData as any).default;
  public defaultColumns = [
    { name: 'identifier' },
    { name: 'orderCode' },
    { name: 'orderName' },
    { name: 'name' },
    { name: 'jobCode' },
    { name: 'totalNumberOfHours' },
    { name: 'budgetType' },
    { name: 'departmentName' }
  ];
  public columnsToExclude = ['identifier'];

  constructor(public budgetsService: BudgetsService) { }

}
